module.exports = __webpack_public_path__ + "static/media/club_house.18cbee4f.jpg";